import { VarParamI } from "./VariableParametrica";

export class FuenteParametroI{
    id : BigInteger;
    fuente : any;
    parametrica : VarParamI;
    obligatoria : Boolean;
}